<template>
  <el-dialog
    title="克隆场景"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    class="mini-dialog"
  >
    <el-form
      :model="formData"
      label-width="160px"
      :rules="formRules"
      ref="formRef"
      class="pl-42px pr-43px"
    >
      <el-form-item label="目标目录" prop="destinationFolderId">
        <el-select
          ref="selectTree"
          v-model="formData.destinationFolderId"
          placeholder="请选择目标目录"
          clearable
          filterable
        >
          <el-option
            v-for="item in sceneFlatData"
            :key="item.id"
            :value="item.id"
            :label="item.name"
            class="hidden"
          ></el-option>
          <el-tree
            :data="treeData"
            :expand-on-click-node="false"
            :props="defaultTreeProps"
            node-key="id"
            highlight-current
            @node-click="handleNodeClick"
          ></el-tree>
        </el-select>
      </el-form-item>
      <el-form-item label="克隆名称" prop="newName">
        <el-input v-model="formData.newName" placeholder="请输入克隆名称" clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'

const modelSceneApi = new ModelSceneApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    operateProps: {
      type: Object,
      default: () => null,
    },
    treeData: {
      type: Array,
      default: [],
    },
    sceneFlatData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        destinationFolderId: '',
        newName: '',
      },
      formRules: {
        destinationFolderId: { required: true, message: '请选择目标目录', trigger: 'change' },
        newName: { required: true, message: '请输入克隆名称', trigger: 'blur' },
      },
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      saveLoading: false,
    }
  },
  created() {
    this.formData.destinationFolderId = this.operateProps.path
    this.formData.newName = this.operateProps.name + '副本001'
  },
  methods: {
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 下拉框点击树形节点回调数据
    handleNodeClick(node) {
      this.formData.destinationFolderId = node.id
      this.$refs.selectTree.blur()
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        this.saveLoading = true
        if (valid) {
          const [err, res] = await modelSceneApi.copyScene({
            ...this.formData,
            id: this.operateProps.id,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '克隆成功',
              type: 'success',
            })
            this.$emit('refresh')
            this.handleClose()
          }
        }
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>